import { render, staticRenderFns } from "./load-catalog-file.vue?vue&type=template&id=4cfd9870&scoped=true"
import script from "./load-catalog-file.vue?vue&type=script&lang=js"
export * from "./load-catalog-file.vue?vue&type=script&lang=js"
import style0 from "./load-catalog-file.vue?vue&type=style&index=0&id=4cfd9870&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cfd9870",
  null
  
)

export default component.exports